module.exports = __webpack_public_path__ + "img/delta.93e25676.png";